<span [innerHTML]="highlightedContent"></span>
